import { FETCH_ALL_PARAMS } from 'constants/query';
import { useGetCompaniesQuery } from 'features/company/services';
import { useMemo } from 'react';
import { configureTableColumns } from 'utils/table-helpers';
import { mapToSelectOptions } from 'utils/filter-select-helpers';
import { useRole } from 'hooks/useRole';
import { ArrowRight } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useTable from 'hooks/useTable';
import { useWebsiteTableColums, WebsitesColumns } from '../constants/table-settings';

const useController = () => {
    const navigate = useNavigate();
    const { isAdmin } = useRole();

    const { data: companies } = useGetCompaniesQuery(FETCH_ALL_PARAMS, {
        skip: !isAdmin,
    });

    const filterSelectOptions = useMemo(() => {
        if (!companies) return;
        return {
            companyName: mapToSelectOptions(companies.content),
        };
    }, [companies]);

    const { tableSettings } = useTable<WebsitesColumns>({
        columns: configureTableColumns(useWebsiteTableColums(), filterSelectOptions || {}),
        queryIdentifier: 'websites',
        renderAddButton: isAdmin,
        customActions: [
            { icon: <ArrowRight />, onClick: (id) => navigate(`/workspace/${id}/website/${id}/sanity-studio`) },
        ],
    });

    return {
        tableSettings,
    };
};

export default useController;
